import { takeLatest, call, put } from 'redux-saga/effects'
import { createRichTextInstance } from 'api/administration/blocks/Create'
import lessonBlocksList from 'api/administration/blocks/List'
import I18n from 'i18n'
import { ErrorToast } from 'components/ui/toast/toastsTemplates'
import * as fromActions from '../../../actions/blocks.action'

async function handleCreateRichTextBlock(data: any) {
  return await createRichTextInstance(data)
}

async function getList(lessonId: number) {
  return await lessonBlocksList(lessonId)
}

function* newRichTextBlockEffectSaga(action: any) {
  try {
    const { data } = action
    const result = yield call(handleCreateRichTextBlock, data)
    yield put(fromActions.Actions.createBlockInstanceSuccess(result))
    const {
      block_instance: { lesson_id },
    } = data
    const blocks = yield call(getList, lesson_id)
    yield put(fromActions.Actions.getLessonBlocksListSuccess(blocks))
  } catch (error) {
    yield put(fromActions.Actions.setLoading(false))
    ErrorToast(I18n.t('administration.toastMessages.genericError'))
    console.log('error: ', error)
  }
}

export function* createRichTextWatcherSaga() {
  yield takeLatest(
    fromActions.RICHTEXT_BLOCK_CREATE,
    newRichTextBlockEffectSaga
  )
}
